<div class="view-all">
    <span class="title">{{title}}</span>
    <div class="events" *ngFor="let event of events">
        <finder-anchor class="name" *ngIf="event.href && showLinks; else noLink"
            [href]="event.href">
            {{event.name}}
        </finder-anchor>
        <ng-template #noLink>
            <span class="name">{{event.name}}</span>
        </ng-template>
        <ng-container *ngIf="event?.schedules[date]">
            <span class="schedules" *ngFor="let schedule of event.schedules[date]">{{schedule.time}}</span>
        </ng-container>
    </div>
</div>
